import { useQuery, useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  getStockProductos, getStockProductosPaginado, getGeneros, getProductoByID,
  getProductoMasVendidoEmpresa2, getAllProducts, getStockBolsa2,
  getComunasYMaquinasPorProductoNombre, getDestacados, productosMasVendidosByAddress, productoBuscado,
  productoBuscadoByEmpresa, getAllProductsByEmpresa
} from "../api";


export const ListaProductos = (id) => {

  const query = useQuery(
    // 1. La queryKey ahora solo depende del 'id'
    ['listaProductos', id],
    // 2. La función de servicio solo necesita el 'id'
    () => getStockProductos(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutos
      // 3. El 'enabled' se activa solo cuando el 'id' es un valor válido
      enabled: !!id,
    }
  );

  return query;
};

export const ListaProductosInfinita = (id) => {
  return useInfiniteQuery(
    ['listaProductosInfinita', id],
    ({ pageParam = 1 }) => getStockProductosPaginado(id, pageParam),
    {
      getNextPageParam: (lastPage, allPages) => lastPage.next ? allPages.length + 1 : undefined,
      staleTime: 1000 * 60 * 10,
      enabled: !!id,
    }
  );
};

export const ListaGeneros = () => {
  const query = useQuery(
    ['listaGeneros'],
    () => getGeneros(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}

export const useProductById = (id = 0) => {
  const query = useQuery(
    ['productById', id],
    () => getProductoByID(id),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}

export const useListaProductosMasVendidos = () => {
  const query = useQuery(
    ['listaProductosMasVendidos'],
    () => getProductoMasVendidoEmpresa2(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}

export const useListaProductosDisponibles = () => {
  const query = useQuery(
    ['listaProductosDisponibles'],
    () => getAllProducts(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}

export const useListaProductosDisponiblesByEmpresa = (id) => {
  const query = useQuery(
    ['listaProductosDisponiblesByEmpresa', id],
    () => getAllProductsByEmpresa(id),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
      enabled: !!id, // Only run if id is truthy
    }
  );
  return query;
}

export const useValidStockBolsa = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['useValidStockBolsa'],
    mutationFn: getStockBolsa2,
    onSuccess: (status) => {
      // obtener prev cache
      const prev = queryClient.getQueryData(['stockBolsa']);
      const prevIds = (prev && prev.productsId) ? (prev.productsId || []) : [];
      const nextIds = (status && status.productsId) ? (status.productsId || []) : [];

      // normalizar y comparar
      const prevNorm = prevIds.map(String).sort();
      const nextNorm = nextIds.map(String).sort();
      const same =
        prevNorm.length === nextNorm.length &&
        prevNorm.every((v, i) => v === nextNorm[i]);

      if (!same) {
        queryClient.setQueryData(['stockBolsa'], status, {
          updatedAt: Date.now() + 100000,
        });
      }

      return status;
    },
  });
  return query;
};

export const useListaComunasYMaquinasPorProductoNombre = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['listaComunasYMaquinasPorProductoNombreMutate'],
    mutationFn: getComunasYMaquinasPorProductoNombre,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['listaComunasYMaquinasPorProductoNombre'],
        status,
        {
          updatedAt: new Date().getTime() + 100000
        }
      );
      return status;
    },
  });

  return query;
}

export const useDataProductoBuscado = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['dataProductoBuscadoMutate'],
    mutationFn: productoBuscado,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['dataProductoBuscado'],
        status,
        {
          updatedAt: new Date().getTime() + 100000
        }
      );
      return status;
    },
  });

  return query;
}

export const useDataProductoBuscadoByEmpresa = () => {
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['dataProductoBuscadoByEmpresaMutate'],
    mutationFn: productoBuscadoByEmpresa,
    onSuccess: (status) => {
      queryClient.setQueryData(
        ['dataProductoBuscadoByEmpresa'],
        status,
        {
          updatedAt: new Date().getTime() + 100000
        }
      );
      return status;
    },
  });

  return query;
}

export const useListaProductosDestacados = () => {
  const query = useQuery(
    ['listaProductosDestacados'],
    () => getDestacados(),
    {
      staleTime: 1000 * 60 * 10,// 10 Minutos
    }
  );
  return query;
}


export const useListaProductosMasVendidosByAddress = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['mutateProductosMasVendidosByAddress'],
    mutationFn: productosMasVendidosByAddress,
    onSuccess: (status) => {
      queryClient.setQueryData(['listaProductosMasVendidosByAddress'], status);
      return status;
    },
  });
}

